// 设置接口部分属性可选
export type PartPartial<T, D extends keyof T> = Partial<Pick<T, D>> & Omit<T, D>;
// 创建一个接口所有属性都为某一类型
export type TypeAll<T extends keyof any, D> = { [k in T]: D };
// 带页码的返回体
export interface CommonWithPageReqType<T> {
  content: T;
  page_count: number;
  page_num: number;
  page_size: number;
  total: number;
}
export type ProfileRepoItemResData = {
  object_id: string;
  type: string;
  resource_id: string;
  data: RepoItemResData;
};
export type RepoItemResData = {
  id: number;
  name: string;
  namespace: string;
  path: string;
  develop_mode: string;
  tag_list: any[];
  visibility: string;
  star_count: number;
  forks_count: number;
  open_issues_count: number;
  open_merge_requests_count: number;
  open_change_requests_count: number;
  starred: boolean;
  name_with_namespace: string;
  path_with_namespace: string;
  web_url: string;
  last_activity_at: Date;
  main_repository_language: null[];
  forked_from_project: null;
  permissions: null;
  archived: boolean;
  member_count: number;
  description: null;
  repository_size: number;
  repo_type: `${RepoType}`;
  [propName: string]: any;
};

export enum RepoType {
  repo = '0',
  model = '1',
  dataset = '2',
  spaces = '3'
}

export enum RepoTypeReportText {
  repo = '项目',
  model = '模型',
  dataset = '数据集',
  spaces = 'spaces',
  issue = 'issue',
  pullrequest = 'PR',
  group = '组织',
  user = '用户',
  commit = 'commit',
  tag = '标签'
}

export type TRepo = 'repo' | 'model' | 'dataset';

export type Str2Num<T extends string> = (T extends `${infer A extends number}` ? A : never) extends infer N extends
  number
  ? N
  : never;

export type TransferParamsOption = [
  /** 需要转移的key*/
  originKey: string | ((obj: any) => string),
  /** 转移后的key*/
  transferKey: string,
  /** 转移后的默认值*/
  defaultValue?: unknown
];

/** http状态码 */
export enum errorCodeType {
  /** 资源不存在 */
  NOT_FOUND = 404,
  /** 无权限 */
  NO_ACCESS = 403,
  /** 审核中 */
  PENDING_REVIEW = 451
}

// space构建类型
export enum SpaceBuildEnum {
  Gradio = 'Gradio',
  Static = 'Static'
}

/** api类型 */
export enum ApiType {
  /** 社区devpress的接口 */
  DEVPRESS = 'devApi',
  /** 主站 */
  MAIN = 'mainApi',
  /** chat */
  CHAT = 'chatApi'
}

export interface AuthStateInfo {
  /** 校验码 */
  state: string;
  /** 来源平台的标识 */
  stateFrom?: string;
}
